import { Navigate, useSearchParams } from 'react-router-dom';
import { CHEMISTRY_LAB_PATH, chemistryLabCard, chemistryLabYear } from './chemistryLabNavigation';

/** Catalogue launch route keeps Study visibility gates and opens the independent workspace. */
export function ChemistryLabStudyEntry() {
  const [params] = useSearchParams();
  const search = new URLSearchParams({ from: 'chemistry' });
  search.set('year', chemistryLabYear(params.get('year')) ?? 'all');
  const card = chemistryLabCard(params.get('card'));
  if (card) search.set('card', card);
  else if (params.get('view') === 'experiments') search.set('view', 'experiments');
  return <Navigate to={`${CHEMISTRY_LAB_PATH}?${search}`} replace />;
}
